import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniFirmsTable } from "@/features/cni-firms/components/CniFirmsTable"

export const Route = createFileRoute("/_authed/cni/firms/")({
  component: CniFirmsPage,
})

function CniFirmsPage() {
  const { t } = useTranslation("cni-firms")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniFirmsTable />
    </div>
  )
}
